/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { gridSize } from '@atlaskit/theme';

import { overflowEllipsis } from 'src/styles/mixins';

export const JiraIssueWrapper = styled.div({
  paddingTop: `${gridSize()}px`,
  maxWidth: `${gridSize() * 110}px`,
  overflow: 'hidden',
});

export const JiraIssueInnerWrapper = styled.div({
  display: 'flex',
  paddingBottom: `${gridSize() / 2}px`,
});

export const JiraIssueKeyContainer = styled.div({
  paddingRight: `${gridSize()}px`,
  flexShrink: 0,
});

export const JiraIssueTypeIcon = styled.img({
  width: `${gridSize() * 2}px`,
  height: `${gridSize() * 2.5}px`,
  paddingRight: `${gridSize()}px`,
});
export const JiraIssueInnerContainer = styled.div({
  display: 'flex',
  overflow: 'hidden',
});

export const JiraIssueSummary = styled.div(overflowEllipsis());
